import * as React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { cn } from "~/lib/utils";
import { forwardRef } from "react";

export interface AppInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label?: string;
  showLabel?: boolean;
  showError?: boolean;
}

export const AppInput = forwardRef<HTMLInputElement, AppInputProps>(
  (
    {
      name,
      label,
      showLabel = true,
      className = "",
      defaultValue,
      showError = true,
      ...props
    },
    ref
  ) => {
    const {
      control,
      formState: { errors },
    } = useFormContext();

    return (
      <div className="flex flex-col gap-1">
        {showLabel && (
          <label htmlFor={name} className="text-sm font-medium text-foreground">
            {label}
          </label>
        )}
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue ?? ""}
          render={({ field }) => (
            <input
              {...field}
              {...props}
              ref={ref}
              id={name}
              className={cn(
                "w-full rounded-xl border border-input bg-background px-3 py-4 text-base ring-offset-background file:border-0 file:bg-transparent file:text-base file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pr-16",
                className
              )}
            />
          )}
        />
        {errors[name] && showError && (
          <span className="text-sm text-destructive">
            {errors[name]?.message as string}
          </span>
        )}
      </div>
    );
  }
);
